import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TextArea, Typography } from '@guildeducationinc/recess';
import { Checkbox, FormControlLabel } from '@mui/material';
import { RuleType } from '@src/types';
import { hasIncompleteConditions, hasValidConditions } from '@src/utilities/criteriaHelper';
import { DatePicker, RuleTargetType, TrackableButton, useLocale, } from 'pe-core-frontend';
import { useContext, useRef, useState } from 'react';
import { RulesContext } from './Rules';
import { RuleTargetFilter } from './RuleTargetFilter';
export const Rule = (props) => {
    const { t } = useLocale();
    const rulesProps = useContext(RulesContext);
    const [errors, setErrors] = useState({});
    const policyValidationRef = useRef(null);
    // eslint-disable-next-line require-await
    const handleSaveRule = async () => {
        const newErrors = {};
        // Validate filter conditions if target is FILTER
        if (props.rule.target === RuleTargetType.FILTER) {
            if (hasIncompleteConditions(props.rule.criteria)) {
                newErrors.criteria = 'All filter conditions must be completed before saving';
            }
            else if (!hasValidConditions(props.rule.criteria)) {
                newErrors.criteria =
                    'At least one complete filter condition is required when using Specific Conditions';
            }
        }
        if (props.rule.isException) {
            if (!props.rule.startsOn) {
                newErrors.startsOn = t('Start date is required');
            }
            if (!props.rule.expiresOn) {
                newErrors.expiresOn = t('End date is required');
            }
            if (props.rule.startsOn &&
                props.rule.expiresOn &&
                new Date(props.rule.startsOn) > new Date(props.rule.expiresOn)) {
                newErrors.expiresOn = t('End date must be after start date');
            }
            if (!props.rule.comment?.trim()) {
                newErrors.comment = t('Comment is required');
            }
        }
        // Call policy validation if available
        if (policyValidationRef.current) {
            const policyErrors = policyValidationRef.current();
            Object.assign(newErrors, policyErrors);
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        props.onSave();
    };
    const handleCancelRule = () => {
        props.onCancel();
    };
    return (_jsxs("div", { className: 'flex flex-col border border-1 border-gray-300 my-2', children: [_jsx("div", { className: 'bg-gray-100 p-2', children: _jsx(Typography, { variant: 'title3', children: props.rule.ruleType === RuleType.ELIGIBILITY ? t('Rule') : t('Rules') }) }), _jsxs("div", { className: 'p-4', children: [rulesProps.children({
                        clientId: rulesProps.clientId,
                        policy: props.rule.policy,
                        onChange: policy => props.onChange({ ...props.rule, policy }),
                        getValidationErrors: policyValidationRef,
                        errors,
                    }), _jsxs("div", { className: 'flex flex-col gap-3', children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: props.rule.isException ?? false, onChange: e => props.onChange({ ...props.rule, isException: e.target.checked }) }), label: t('Is this policy an exception?') }), props.rule.isException && (_jsxs(_Fragment, { children: [_jsx(DatePicker, { label: t('Start Date'), value: props.rule.startsOn ?? '', onChange: dt => props.onChange({ ...props.rule, startsOn: dt }), errors: errors['startsOn'] ?? undefined }), _jsx(DatePicker, { label: t('End Date'), value: props.rule.expiresOn ?? '', onChange: dt => props.onChange({ ...props.rule, expiresOn: dt }), errors: errors['expiresOn'] ?? undefined }), _jsx(TextArea, { label: t('Comment'), value: props.rule.comment ?? '', onChange: e => props.onChange({ ...props.rule, comment: e.currentTarget.value }), errors: errors['comment'], required: true, fullWidth: true, rows: 4 })] }))] })] }), _jsx(RuleTargetFilter, { rule: props.rule, type: props.rule.ruleType, onChange: rule => {
                    // Clear validation errors when user starts editing
                    if (errors['criteria']) {
                        const { criteria, ...remainingErrors } = errors;
                        setErrors(remainingErrors);
                    }
                    props.onChange({ ...props.rule, ...rule });
                }, clientId: rulesProps.clientId, targetPopulationEntityEnumType: rulesProps.targetPopulationEntityEnumType, defaultTargetPopulationEntityType: rulesProps.defaultTargetPopulationEntityType }), errors['criteria'] && (_jsx("div", { className: 'text-red-600 mt-2 mx-4 p-2 bg-red-50 border border-red-200 rounded', children: errors['criteria'] })), _jsx("div", { className: 'p-4', children: _jsxs("div", { className: 'flex flexJustify--space_between gap-1 py-1 mt-3', children: [_jsx(TrackableButton, { btnType: 'mui', enText: 'Cancel', tag: props.rule.ruleType, variant: 'outlined', onClick: () => handleCancelRule(), children: t('Cancel') }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Save', tag: props.rule.ruleType, variant: 'contained', onClick: () => handleSaveRule(), children: t('Save') })] }) })] }));
};
